var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsulting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1644573188311,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7155,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1011.2 620.8l-97.6-97.6-110.4 51.2c-20.8 8-30.4 33.6-20.8 56 8 20.8 33.6 30.4 56 20.8l17.6-8c-25.6 68.8-72 128-132.8 166.4V672c0-89.6-68.8-161.6-148.8-161.6h-8c56-20.8 89.6-72 89.6-132.8 0-76.8-64-140.8-140.8-140.8s-140.8 64-140.8 140.8c0 59.2 38.4 110.4 94.4 132.8H448c-81.6 0-148.8 72-148.8 161.6v128c-59.2-43.2-107.2-107.2-128-179.2-8-20.8-30.4-33.6-56-25.6-20.8 8-33.6 30.4-25.6 56 59.2 184 235.2 312 427.2 312s358.4-120 422.4-294.4l12.8 12.8c8 8 20.8 12.8 30.4 12.8s20.8-4.8 30.4-12.8c16-17.6 16-43.2-1.6-60.8zM516.8 326.4c30.4 0 56 25.6 56 56s-25.6 56-56 56-56-25.6-56-56 20.8-56 56-56zM384 856v-176c0-43.2 30.4-76.8 64-76.8h38.4l-17.6 72 43.2 136 43.2-136-17.6-76.8H576c33.6 0 64 33.6 64 76.8v179.2h4.8c-38.4 17.6-84.8 25.6-128 25.6-48 1.6-89.6-11.2-132.8-24z",
    "p-id": 7156
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M230.4 454.4c20.8-12.8 30.4-38.4 17.6-59.2-12.8-20.8-38.4-30.4-59.2-17.6l-12.8 8c51.2-140.8 187.2-238.4 340.8-238.4 166.4 0 315.2 115.2 353.6 276.8 4.8 20.8 30.4 38.4 51.2 30.4 20.8-4.8 38.4-30.4 30.4-51.2C900.8 203.2 721.6 62.4 512 62.4c-196.8 0-366.4 128-427.2 312l-12.8-12.8c-17.6-17.6-43.2-17.6-59.2 0s-17.6 43.2 0 59.2l97.6 97.6 120-64z",
    "p-id": 7157
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsulting);
export default __webpack_public_path__ + "static/media/consulting.deb4c151.svg";
export { ForwardRef as ReactComponent };